export interface AdaptiveQualityGateOptions {
  enabled: boolean;
  warmupFrames: number;
  slowFrameSeconds: number;
  sustainedFrames: number;
}

export interface AdaptiveQualityGate {
  tick(frameDt: number): boolean;
}

export function createAdaptiveQualityGate({
  enabled,
  warmupFrames,
  slowFrameSeconds,
  sustainedFrames,
}: AdaptiveQualityGateOptions): AdaptiveQualityGate {
  let frameCount = 0;
  let consecutiveSlowFrames = 0;
  let reduced = false;

  return {
    tick(frameDt: number): boolean {
      frameCount += 1;
      if (!enabled || reduced) return false;
      if (frameCount <= warmupFrames) {
        consecutiveSlowFrames = 0;
        return false;
      }

      if (frameDt > slowFrameSeconds) {
        consecutiveSlowFrames += 1;
      } else {
        consecutiveSlowFrames = 0;
      }

      if (consecutiveSlowFrames < sustainedFrames) return false;
      reduced = true;
      return true;
    },
  };
}
